import React from 'react';
import classNames from 'classnames';
import { Progress } from 'antd';
import { useThemeVarsClass } from '../../../../theme/provider';
import cn from './styles.module.scss';

export type CircleProgressProps = {
  current: number;
  total: number;
  label: string;
  color?: string;
};

export function CircleProgress({
  current, total, label, color,
}: CircleProgressProps) {
  const themeClassName = useThemeVarsClass();
  const percent = 100 * (current / total);
  return (
    <div className={classNames(cn.container, themeClassName)}>
      <div className={cn.bar}>
        <Progress type="circle" percent={percent} size={60} strokeColor={color} strokeWidth={8} showInfo={false} />
        <div className={cn.progress}>
          <span className={cn.result}>
            {current}
            /
            {total}
          </span>
          <span className={cn.label}>{label}</span>
        </div>
      </div>
    </div>
  );
}
